import { createSelector, } from 'reselect';
import { omit, reduce, } from 'ramda';

import { CartShopStats, ItemsInShopAmountType, ShopCartItem, } from './types';
import { PRODUCTS_PRODUCT_ITEM_MAP } from 'api/repositories/Products/Products';
import { makeImagesCollectionToDict } from 'common/functions';

type MappingShopCartItems = {
    shopCart: Array<ShopCartItem>,
};

const getShopCartItems = ({ shopCart, }: MappingShopCartItems) => shopCart;
const getDictItemsInCart = (items: ItemsInShopAmountType, item: ShopCartItem) => item.quantity
    ? { ...items, [item.code]: item.quantity, }
    : omit(item.code, item);

export const getItemsAmountInCartShop = createSelector(
    [ getShopCartItems ],
    reduce(getDictItemsInCart, {}),
);

// TODO PB Handle a set case.
export const getSumPrice = (items: CartShopStats, item: ShopCartItem) => items.sumPrice + (item.quantity * (item.details?.price || 0));
export const getAmount = (items: CartShopStats, item: ShopCartItem) => items.amount + item.quantity;
export const getStats = (items: CartShopStats, item: ShopCartItem) => ({
    amount: getAmount(items, item),
    sumPrice: getSumPrice(items, item),
});

export const sumStatsInCartShopItems = createSelector(
    [ getShopCartItems, ],
    reduce(getStats, { amount: 0, sumPrice: 0, })
);

const mapGrantProducts = (item: any) => ({
    name: item.name,
    quantity: item.quantity,
    price: item.unitPrice,
    taxAmount: item.taxAmount,
});

const sumGrantProductsPrices = (sum: number, item: any) => sum + (item.unitPrice * item.quantity);

export const transformCartItems = (data: any) => data.map(({ product, quantity, id, configuration, }: any = {}) => {
    const isGrantSet = product.type === PRODUCTS_PRODUCT_ITEM_MAP.GRANT_SET;
    const images = Array.isArray(product.images)
                   ? product.images.reduce(makeImagesCollectionToDict, {})
                   : product.images;

    return {
        code: product.code,
        quantity,
        details: {
            id,
            name: product.name,
            type: product.type,
            slug: product.slug,
            price: product.price.current,
            images,
            minQuantity: product.minQuantity ?? 0,
            taxAmount: product.taxAmount,
            ...(isGrantSet && { price: configuration.reduce(sumGrantProductsPrices, 0), }),
            ...(isGrantSet && { products: configuration.map(mapGrantProducts), }),
        },
    }
});
